'use strict';

var _select = require('linksoft/initializers/select2');

var Select2 = _interopRequireWildcard(_select);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var $ = require("jquery");

var Resx = (0, _localize2.default)('Common', 'App', 'Messages');
var customerService = abp.services.api.customerB2c;

module.exports = exports.default = function () {

    $("#customer", this).off("click").on("click", "a[data-modal-link]", function (e) {
        e.preventDefault();
        var $buttonClicked = $(this);

        var url = $buttonClicked.attr("data-url");
        var targetId = $buttonClicked.attr("data-target-id");

        $.get(url, function (data) {
            var targetDialog = $('#' + targetId);
            targetDialog.children().children().html(data);

            Select2.initSelect2($("#CountryId"));
            $.validator.unobtrusive.parse("form");

            targetDialog.modal("show");
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/customerActions.js
// module id = 1170
// module chunks = 0